(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    (function () {
    // Hooking into the DOM load event to run our code after the DOM is ready ( to make sure calculations are correct )
    const onReady = function (fn) {
      if (typeof fn !== 'function') return console.warn('onReady skipped: No proper function provided');

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        queueMicrotask ? queueMicrotask(fn) : fn();
      }
    };

    const calcAutoCompleteTop = function () {
      let autocompleteTop = 0;
      const headerTop = document.querySelector('.shopify-section-group-header-group .toolbar');
      const siteHeaderIsSticky = document.querySelector('.site-header--stuck');

      if (headerTop) {
        autocompleteTop = siteHeaderIsSticky ? 0 : headerTop.getBoundingClientRect().top + headerTop.clientHeight;
      }

      document.body.style.setProperty('--nl-autocomplete-top', `${autocompleteTop}px`);
    };

    const initExtras = function () {
      const autocompleteForm = document.querySelector('predictive-search .aa-Form');
      const autocompleteScreen = document.querySelector('predictive-search .predictive__screen');
      if (!autocompleteForm || !autocompleteScreen) return;

      const closeButtonEl = document.createElement('button');
      closeButtonEl.classList.add('aa-CloseButton');
      autocompleteForm.append(closeButtonEl);

      const closeButton = autocompleteForm.querySelector('.aa-CloseButton');

      if (!closeButton) return;

      closeButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const searchPanel = document.querySelector('.aa-Panel');

        if (searchPanel) {
          searchPanel.remove();
        }

        if (autocompleteScreen) {
          autocompleteScreen.click();
        }
      });
    };

    const stateIsDefault = function (state) {
      const cleanQuery = state.query.trim();
      return cleanQuery === '' /* || cleanQuery.length <= 3 */ && state.isOpen === true;
    };

    const adaptPanelHeight = function () {
      window.setTimeout(function () {
        const algoliaPanel = document.querySelector('.aa-Panel');
        document.body.style.setProperty('--nl-algolia-panel-top', `${algoliaPanel?.getBoundingClientRect().top}px`); // Adapting panel height to design
      }, 50);
    }

    const getAlgoliaDynamicIndexes = function () {
      const predictiveSearchEl = document.querySelector('predictive-search');
        const currentMarket = predictiveSearchEl?.getAttribute('data-algolia-index-suffix')
          ? predictiveSearchEl.getAttribute('data-algolia-index-suffix')
          : '';

        const brand = predictiveSearchEl?.getAttribute('data-algolia-brand');
        const currentLanguage = window.algoliaShopify.shopify.market.language.shop_locale.locale;
        const currentMarketSuffix = currentMarket ? `${currentMarket}_` : '';

        return {
          suffix: `_${currentMarketSuffix}${currentLanguage}`,
          suggestions : `shopify_${brand}_query_suggestions_${currentLanguage}`,
          brand: brand
        }

    }

    const NL_i18n_Algolia = {};
    const NL_Algolia_form = document.querySelector('form[data-search="algolia"]');
    NL_i18n_Algolia['autocomplete_placeholder'] = NL_Algolia_form?.getAttribute('data-placeholder');
    const NL_Algolia_default_template_section = document.querySelector('#nl__aa-Default-Template-template');
    let NL_Algolia_default_template;

    if (NL_Algolia_default_template_section) {
      NL_Algolia_default_template = NL_Algolia_default_template_section.innerHTML;
    }

    document.addEventListener('algolia.hooks.initialize', function () {
      algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
        const algolia = window.algoliaShopify;
        const config = algolia.config;
        const algoliaTranslationsMetafieldEl = document.querySelector('[data-algolia-custom-translation-keys]');
        let algoliaCustomTranslationKeys = {};

        if (algoliaTranslationsMetafieldEl) {
          algoliaCustomTranslationKeys = JSON.parse(
            algoliaTranslationsMetafieldEl?.getAttribute('data-algolia-custom-translation-keys')
          );
        }

        // Customize options here
        options.focus = true; // ToDo: Might be better implementation! Check why focus:true is not working
        options.openOnFocus = true;

        if (algoliaCustomTranslationKeys.clear) {
          options.translations = {
            clearButtonTitle: algoliaCustomTranslationKeys.clear,
          };
        }

        // Timeout is needed for algolia to be ready (it's async so we're setting microtask in queue instead of stack)
        window.setTimeout(initExtras, 100);

        if (NL_i18n_Algolia?.autocomplete_placeholder) {
          options.placeholder = NL_i18n_Algolia.autocomplete_placeholder;
        }

        const algoliaDynamicIndexes = getAlgoliaDynamicIndexes();

        const bannerPlugin = {
          getSources({ query }) {
            return [
              {
                sourceId: "queryRuleBanner",
                async getItems() {
                  const results = await algolia.searchClient.search([
                    {
                      indexName: `shopify_${algoliaDynamicIndexes.brand}_products${algoliaDynamicIndexes.suffix}`,
                      query,
                      params: {
                        hitsPerPage: 0,
                        clickAnalytics: false,
                        ruleContexts: ["autocomplete-banner"],
                      },
                    },
                  ]);

                  const renderingContent =
                    results.results[0]?.renderingContent;
                  const banners =
                    renderingContent?.widgets?.banners;

                  if (!banners || banners.length === 0) return [];

                  // Return banners as synthetic items so Autocomplete can render them
                  return banners.map((banner, i) => ({
                    __autocomplete_id: `banner-${i}`,
                    imageUrl: banner.image?.urls[0]?.url ?? null,
                    linkUrl: banner.link?.url ?? null,
                  }));
                },
                templates: {
                  item({ item, html }) {
                    if (!item.imageUrl) return null;

                    const wrapper = item.linkUrl
                      ? html`<a href=${item.linkUrl} class="aa-BannerLink">
                          <img
                            src=${item.imageUrl}
                            class="aa-BannerImage"
                            alt="Banner"
                          />
                        </a>`
                      : html`<div class="aa-Banner">
                          <img
                            src=${item.imageUrl}
                            class="aa-BannerImage"
                            alt="Banner"
                          />
                        </div>`;

                    return wrapper;
                  },
                },
              },
            ];
          },
        };

        options.plugins.push(bannerPlugin);

        return options;
      });

      algoliaShopify.hooks.registerHook('beforeAutocompleteAsyncFunction', async function () {
        const algoliaDynamicIndexes = getAlgoliaDynamicIndexes();

        console.log('algoliaDynamicIndexes', algoliaDynamicIndexes);

        window.algoliaShopify.config.index_suffix = algoliaDynamicIndexes.suffix;
        window.algoliaShopify.config.query_suggestions_index_name = algoliaDynamicIndexes.suggestions;
      });

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainTemplate',
        function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          const { html, state } = templateOptions;

          adaptPanelHeight();

          if (stateIsDefault(state)) {
            return html`<div dangerouslySetInnerHTML=${{ __html: NL_Algolia_default_template }} />`; // Return empty template when no query
          }

          return html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-PanelSections">
                <div class="aa-PanelSection--left">
                  ${
                    displaySuggestions &&
                    html`
                      <div class="aa-SourceHeader">
                        <span class="aa-SourceHeaderTitle"
                          >${algoliaShopify.translations.suggestions}</span
                        >
                        <div class="aa-SourceHeaderLine" />
                      </div>
                      ${elements.querySuggestionsPlugin}
                    `
                  }
                  ${elements.collections} ${elements.pages}
                  ${elements.redirectUrlPlugin}
                </div>
                <div class="aa-PanelSection--right">
                  ${elements.queryRuleBanner && html`<div class="aa-PanelSection--banners">${elements.queryRuleBanner}</div>`}
                  ${elements.products}
                </div>
              </div>
            </div>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteNoResultsTemplate',
        function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
          const { html, state } = templateOptions;

          adaptPanelHeight();

          const NL_Algolia_default_template_panel = html`<div dangerouslySetInnerHTML=${{ __html: NL_Algolia_default_template }} />`

          if (stateIsDefault(state)) {
            return NL_Algolia_default_template_panel; // Return empty template when no query
          }

          return html`
            <div class="aa-PanelLayout aa-Panel--scrollable">
              <div class="aa-no-results">
                <p class="aa-NoResultsHeader">
                  ${algoliaShopify.translation_helpers.no_result_for(state.query)}
                </p>
                <a class="btn btn--secondary btn--small" href="${window.Shopify.routes.root}collections/all">
                  ${algoliaShopify.translations.allProducts}
                </a>
              </div>
              <div class="aa-no-results--default-template">
                ${NL_Algolia_default_template_panel}
              </div>
            </div>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        "beforeAutocompleteCollectionsTemplate",
        (_defaultTemplate, templateOptions, itemLink) => {
          const { html, item, components } = templateOptions;
          return html`
            <a href="${itemLink}" class="aa-ItemLink">
              <div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                  <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                      />
                    </svg>
                  </div>
                  <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">${item.title}</div>
                  </div>
                </div>
              </div>
            </a>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompletePagesTemplate',
        (_defaultTemplate, templateOptions, itemLink) => {
          const { html, item, components } = templateOptions;
          return html`
            <a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
              <div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                  <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">${item.title}</div>
                  </div>
                </div>
              </div>
            </a>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteSuggestionsTemplate',
        function (_defaultTemplate, templateOptions) {
          const { html, state, item, components } = templateOptions;

          adaptPanelHeight();

          return html`
            <a class="aa-ItemLink aa-ItemWrapper" href="${window.Shopify.routes.root}search?q=${item.query}">
              <div class="aa-ItemContent">
                <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path
                      d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"
                    />
                  </svg>
                </div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitle">${item.query}</div>
                </div>
              </div>
            </a>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteMainProductsTemplate',
        function (_defaultTemplate, templateOptions, elements) {
          const { html, state } = templateOptions;

          adaptPanelHeight();

          if (stateIsDefault(state)) {
            return html`<div dangerouslySetInnerHTML=${{ __html: NL_Algolia_default_template }} />`; // Return empty template when no query
          }

          return _defaultTemplate;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteProductTemplate',
        function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
          // Modify default options, then return them
          const { html, item, components } = templateOptions;

          const itemTitleMap = window.AlgoliaHelpers.getBasicNetTitleParts(item.title);

          // Prices formats
          const itemIsOnSale = window.AlgoliaHelpers.isOnSale(item);
          const itemPriceVaries = window.AlgoliaHelpers.doesItemPriceVary(item);
          const variantMinPrice = item.variants_min_price;
          const variantCompareAtPriceMin = item.variants_compare_at_price_min;
          const variantCurrency = item.currency;
          const itemOmnibus = window.AlgoliaHelpers.getOmnibusPrice(item);

          const displayOmnibusNotice = itemOmnibus?.amount > 0 && itemIsOnSale;
          const omnibusPrice = displayOmnibusNotice ? parseInt(itemOmnibus?.amount, 10) * 100 : variantCompareAtPriceMin;

          let displayPrice = window.AlgoliaHelpers.wrapCurrency(algoliaShopify.formatMoney(variantMinPrice * 100, variantCurrency));
          const strikedPrice = window.AlgoliaHelpers.wrapCurrency(
            algoliaShopify.formatMoney(variantCompareAtPriceMin * 100, variantCurrency)
          );

          const omnibusNoticePrice = window.AlgoliaHelpers.wrapCurrency(algoliaShopify.formatMoney(omnibusPrice, variantCurrency));

          if (itemPriceVaries) {
            displayPrice = window.AlgoliaHelpers.addPriceVariesLabel(displayPrice);
          }

          const strikedPriceTemplate = strikedPrice
            ? html`<span class="aa-SalePrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: strikedPrice }} />`)()}</span
              >`
            : '';

          const sellingPriceTemplate = itemIsOnSale
            ? html`<span class="aa-RegularPrice aa-RegularPrice--on-sale"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`
            : html`<span class="aa-RegularPrice"
                >${(() => html`<span dangerouslySetInnerHTML=${{ __html: displayPrice }} />`)()}</span
              >`;

          const saleLabel = itemIsOnSale
            ? html`<span class="aa-SaleLabel grid-product__tag grid-product__tag--sale"></span>`
            : ''; // ToDo: dynamic value for label

          const omnibusNotice = displayOmnibusNotice
            ? html`<div class="aa-ItemContentPricePrevious">
                <span class="aa-OmnibusNotice grid-product__notice--omnibus"
                  >
                  ${(() => html`<span dangerouslySetInnerHTML=${{ __html: omnibusNoticePrice }} />`)()}</span
                >
              </div>`
            : '';

          return html`
            <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
              <div class="aa-ItemContent">
                ${saleLabel}
                <div class="aa-ItemPicture aa-ItemPicture--loaded">
                  <img
                    src="${algoliaShopify.helpers.renderImage(item, 230).src}"
                    srcset="${algoliaShopify.helpers.renderImage(item, 230).srcset}"
                    sizes="${algoliaShopify.helpers.renderImage(item, 230).sizes}"
                    alt="${item.title}"
                  />
                </div>
                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitleWrapper">
                    <div class="aa-ItemContentTitle">
                      ${itemTitleMap.title}
                      <span hidden>${components.Highlight({ hit: item, attribute: 'title' })}</span>
                      <span class="algolia-variant">
                        ${itemTitleMap.color}
                        <span hidden>${algoliaShopify.helpers.variantTitleAddition(item, distinct)}</span>
                      </span>
                    </div>
                  </div>
                  <div class="aa-ItemContentPrice">
                    <div class="aa-ItemContentPriceCurrent">
                      ${sellingPriceTemplate} ${itemIsOnSale && strikedPriceTemplate}
                    </div>
                    ${omnibusNotice}
                  </div>
                </div>
              </div>
            </a>
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteHeaderTemplate',
        function (_defaultTemplate, templateOptions, resource) {
          const { html, state } = templateOptions;

          const getViewAllLink = () => {
            if (resource == algoliaShopify.translations.products) {
              return html`<a
                class="btn btn--secondary btn--small"
                href="${window.Shopify.routes.root}search?q=${state.query}"
              >
                ${algoliaShopify.translations.allProducts}
              </a>`;
            }
          };

          // ToDo: check if resource is translated
          return html`
            <div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle"> ${resource} </span>
            </div>
            ${getViewAllLink(resource, state.query)}
          `;
        }
      );

      algoliaShopify.hooks.registerHook(
        'beforeAutocompleteFooterTemplate',
        function (_defaultTemplate, templateOptions) {
          const { html, state } = templateOptions;
          return html``; // Removed "See all results" button from footer
        }
      );
    });

    document.addEventListener('predictive-search:open', (e) => {
      window.setTimeout(function () {
        document.querySelector('form.aa-MainContainer input[type="search"]')?.focus();
      }, 100);
    });

    document.addEventListener('click', (e) => {
      const target = e.target;
      const predictiveSearchElement = document.querySelector('predictive-search[data-enabled="true"]');
      const searchPanel = document.querySelector('.aa-Panel');

      if (!predictiveSearchElement || !predictiveSearchElement.classList.contains('is-active')) return;
      if (target.closest('predictive-search') || target.closest('.aa-Panel')) return;

      predictiveSearchElement.close();

      if (searchPanel) {
        searchPanel.remove();
      }
    });

    // Making sure autocomplete top is updated everytime we open it, to compensate for scroll
    const searchBtn = document.querySelectorAll('.js-search-header');
    if (searchBtn && searchBtn.length > 0) {
      searchBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
          calcAutoCompleteTop();
        });
      });
    }

    // Making sure autocomplete top is updated on page load
    onReady(calcAutoCompleteTop);
  })();
  } catch(e) { console.error(e); }
})();

})();
